<script setup lang="ts">
const { result, isSubmitting, onSubmit, onReset } = useAuthForgotPasswordForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit" @reset="onReset">
    <FieldText name="email" type="email" label="Adresse courriel" required />
    <UiSubmitButton :is-submitting="isSubmitting">
      Réinitialiser
    </UiSubmitButton>
  </UiFormWrapper>
</template>
